const state = {
    processExecutionDoGet: false,
    taskListNeedRefresh: false,
};
const getters = {};
const actions = {};
const mutations = {
    setProcessExecutionDoGet(state, val) {
        state.processExecutionDoGet = val;
    },
    setTaskListNeedRefresh(state, val) {
        state.taskListNeedRefresh = val;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}